import './App.css';
import React, {useState, useEffect} from "react";
import {APIProvider} from '@vis.gl/react-google-maps';
import DoorHopperMap from './components/DoorHopperMap';
import Navigation from './components/Navigation';
import AppointmentsList from "./components/AppointmentsList";
import NotificationBar from './components/NotificationBar';
import ClientDetails from './components/ClientDetails';
import LoadingScreen from './components/LoadingScreen';
import {AppCTX} from './data/AppContext';
import Login from './components/Login';
import ProspectDetails from './components/ProspectsList.js';
import TeamSignUp from './components/TeamSignUp';
import SearchAppBar from './components/TopBar';
import Container from '@mui/material/Container';
import AddProspect from './components/AddProspect';
import LeadsDrawer from './components/LeadsDrawer';
import PropertyInsightsTable from './components/PropertyInsightsTable';

function App() {
  const[height, setHeight] = useState(window.innerHeight)
  const[width, setWidth] = useState(window.innerWidth)
  const [showLoading, setShowLoading] = useState(true);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedProspect, setSelectedProspect] = useState(null);
  const [leadsDrawerOpen, setLeadsDrawerOpen] = useState(false); // NEW STATE
  
  // triggering new deployment 
  useEffect(() => {
    // Function to update the inner height state
    const handleResize = () => {
      setHeight(window.innerHeight);
      setWidth(window.innerWidth);
    };

    // Add an event listener for the resize event when the component mounts
    window.addEventListener('resize', handleResize);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Show loading screen for 1.5 seconds on initial mount
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  const {
    newProspect,
    setNewProspect,
    leadType,
    prospects,
    setProspects,
    setLeadType,
    status,
    setStatus,
    user,
    isMapLoaded,
    openAddProspect,
    propertyInsights,
    propertyInsightsLoading,
    propertyInsightsError,
  } = React.useContext(AppCTX);

  // Auto-open drawer when property insights are loaded
  useEffect(() => {
    if (propertyInsights && leadType === 0) {
      setLeadsDrawerOpen(true);
    }
  }, [propertyInsights, leadType]);

  
  if (showLoading) {
    return <LoadingScreen />;
  }

  if(user.uid==null){
    return(
      <div style={{height:'100%', width:'100%'}}  className="App">
        <Login/>
      </div>
    )
  }
  else if(user.uid!=null && user.data==null){
    return (
      <div style={{height:'100%', width:'100%'}} className="App">
        <TeamSignUp/>
      </div>
    )
  }else{
    return (
      <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} libraries={['drawing', 'places']}>
        <div style={{height:'100%', width:'100%'}} className="App"> 
          {/* Always render the map after initial loading, let DoorHopperMap handle errors */}
          <div style={
            {
              position:'fixed',
              top:0,
              zIndex:1,
              width:'100vw'
            }
          }>
            <SearchAppBar/>
          </div>
          <div style={{
              position:'fixed',
              top:0,
              width:width,
              height: '100%',
              zIndex:'0',
              marginTop:50,
            }}>
            <DoorHopperMap
              prospects={prospects}
              apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
              setProspects={setProspects}
              leadType={leadType}
              newProspect={newProspect}
              setNewProspect={setNewProspect}
              showDetails={showDetails}
              setShowDetails={setShowDetails}
              selectedProspect={selectedProspect}
              setSelectedProspect={setSelectedProspect}
            />
          </div>
          
          
            <LeadsDrawer 
              count={prospects.length} 
              status={leadType} 
              showBackdrop={leadType !== 0}
              open={leadsDrawerOpen}
              setOpen={setLeadsDrawerOpen}
            >
              {leadType === 1 && (
                <ProspectDetails 
                  prospects={prospects}
                  showDetails={showDetails}
                  setShowDetails={setShowDetails}
                  selectedProspect={selectedProspect}
                  setSelectedProspect={setSelectedProspect}
                />
              )}
              {leadType === 0 && (
                <PropertyInsightsTable
                  propertyData={propertyInsights}
                  loading={propertyInsightsLoading}
                  error={propertyInsightsError}
                />
              )}
            </LeadsDrawer>
          
          <div style={
            {
              zIndex:'3'
            }
          }>
            <Navigation 
              setCurrentScreen={(newValue) => {
                setLeadType(newValue);
                if (newValue === 0 || newValue === 1 || newValue === 2) {
                  setLeadsDrawerOpen(true);
                } else {
                  setLeadsDrawerOpen(false);
                }
              }}
              currentScreen={leadType}
            />
          </div>
          <div style={
            {
              position:'fixed',
              bottom:0,
              left:40,
              zIndex:'4'
            }
          }>
            {status!=='neutral'? <NotificationBar setStatus={setStatus} status={status}/>:null}
          </div>
          <ClientDetails
            open={showDetails}
            selectedProspect={selectedProspect}
            setSelectedProspect={setSelectedProspect}
            setShowDetails={setShowDetails}
          />
          <AddProspect />
        </div>
      </APIProvider>
    );
  }
}

export default App;
